const FILE_MANAGER_ALLOWED_EMAILS = [
  'tech@pitaway.com',
  'moe@pitaway.com',
];

export const hasFileManagerAccess = (email?: string | null): boolean => {
  if (!email) return false;
  return FILE_MANAGER_ALLOWED_EMAILS.includes(email.toLowerCase());
};

export default FILE_MANAGER_ALLOWED_EMAILS;

